/**
 * Do not edit directly, this file was auto-generated
 */

export const BackgroundColorPink = "#EB80FD";
export const BackgroundColorPurple = "#C09DFF";
export const BackgroundColorPurpleLightest = "#EEE2FF";
export const BackgroundColorPurpleDarkest = "#460095";
export const BackgroundColorRed = "#FF643B";
export const BackgroundColorYellow = "#D8C833";
export const BackgroundColorBlue = "#00B4DC";
export const BackgroundColorBlueDark = "#006C85";
export const BackgroundColorGreen = "#1DBF73";
export const BackgroundColorCream = "#F7F2D8";
export const BackgroundColorBlack = "#000000";
export const BackgroundColorWhite = "#ffffff";
export const BackgroundColorGray = "#F9F9FA";
export const BackgroundColorTest = "#FBD90E";
export const InteractiveColorHover = "#834fca";
export const InteractiveColorHoverAlt = "#eee2ff";
export const InteractiveColorActive = "#d7c0ff";
export const InteractiveColorDisabled = "#CACCCD";
export const InteractiveColorAction = "#460095";
export const InteractiveColorActiveAlt = "#460095";
export const InteractiveColorHoverGray = "#EEE2FF";
export const FeedbackColorBackgroundInformative = "#CCF0F8";
export const FeedbackColorBackgroundCritical = "#FFE1D8";
export const FeedbackColorBackgroundSuccess = "#D2F2E3";
export const FeedbackColorBackgroundWarning = "#F7F2D8";
export const FeedbackColorCritical = "#FF643B";
export const FeedbackColorSuccess = "#1DBF73";
export const FeedbackColorInformative = "#00B4DC";
export const FeedbackColorWarning = "#817224";
export const TextColorDefault = "#000";
export const TextColorSubtle = "#5A5F62";
export const TextColorNonessential = "#9B9EA0";
export const TextColorAction = "#8654CD";
export const TextColorOnDark = "#fff";
export const IconSizeSmall = "16px";
export const IconSizeMedium = "20px";
export const IconSizeLarge = "24px";
export const IconColorStrokeDefault = "#000000";
export const IconColorStrokeDisabled = "#CACCCD";
export const BorderColorDefault = "#E7E8E9";
